import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-password-input',
    template: `
      <mat-form-field class="w-full">
        <mat-label>{{props.label}}</mat-label>
        <input
          matInput
          [type]="showValue() ? 'text' : 'password'"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [placeholder]="props.placeholder ?? ''"
          [required]="!!props.required"
        />
        <button mat-icon-button type="button" matSuffix (click)="showValue.set(!showValue())">
          <mat-icon class="icon-size-5" [svgIcon]="showValue() ? 'heroicons_solid:eye-off' : 'heroicons_solid:eye'"></mat-icon>
        </button>
      </mat-form-field>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, MatSuffix, MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, FormlyModule]
})
export class PasswordInputComponent extends FieldType<FieldTypeConfig> implements OnInit {
    showValue = signal(false);

    ngOnInit(): void {
        this.showValue.set(this.props['masked'] === false);
    }
}
